import React from 'react';
import {AbsenceText} from '../absenceText/AbsenceText.tsx';
import {useHivesStore} from '../../../entities/hives';
import {useApiariesStore} from '../../../entities/apiaries';

type ApiaryHivesAbsenceProps = {
  noHivesText?: string;
  noApiaryText?: string;
  onClickHives?: () => void;
  onClickApiary?: () => void;
  children: React.ReactNode;
};

export const ApiaryHivesAbsence = (props: ApiaryHivesAbsenceProps) => {
  const {
    noHivesText = 'У вас пока нет ульев — добавьте первый.',
    noApiaryText = 'Добавьте пасеку',
    onClickApiary,
    onClickHives,
    children,
  } = props;

  const hives = useHivesStore((s) => s.hives);
  const currentApiary = useApiariesStore((s) => s.currentApiaryId);
  const setIsCreateApiaryOpen = useApiariesStore((s) => s.setIsModalOpen);
  const openPopup = useHivesStore((s) => s.managePopup);

  if (!currentApiary) {
    return (
      <AbsenceText
        text={noApiaryText}
        subText={'Начните с добавления Вашей первой пасеки для начала работы с приложением'}
        buttonText={'Добавить пасеку'}
        onClick={onClickApiary || (() => setIsCreateApiaryOpen(true))}
      />
    );
  }

  if (!hives.length) {
    return (
      <AbsenceText
        text={noHivesText}
        buttonText={'Добавить улей'}
        onClick={onClickHives || (() => openPopup(true))}
      />
    );
  }

  return <>{children}</>;
};
